import { createSlice } from '@reduxjs/toolkit';
import { proc } from '@aexae/js_tools';

import socket from '../../utils/socket';

const { newId } = proc.getQueryParams();

const initialState = {
  isLoading: false,
  error: false,
  // datas
  news: [],
  newId
};

const slice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.error(state.error);
    },

    getNews(state, action) {
      const { news } = action.payload;
      state.isLoading = false;
      state.news = news;
    }
  }
});

// Reducer
export default slice.reducer;

export function getNews() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.get('/news');
      dispatch(slice.actions.getNews(result));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
